module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("6:"), _c('span', {
    staticClass: "space"
  }, [_vm._v(" Snuff Box")])])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("ith all the upheaval in France in 1793, the forces of revolution and counter-revolution clashed continuously, culminating with major insurrections in Lyon, Marseilles and Toulon, home of the vast French naval base for the Mediterranean. Royalists gained control in Toulon but when news reached them of the horrendous brutality of the reprisals inflicted by revolutionary forces after they had recaptured Marseilles, they sought help from Spain and Britain, enemies of France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 28 August 1793 Admiral Sir Samuel Hood’s fleet and a Spanish squadron under Admiral Juan de Lángara sailed into the bay and soon landed some 13,000 British, Spanish, Neapolitan and Piedmontese troops, who manned the outer defences around the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was a major blow to a revolutionary government, which was under attack from all sides and they immediately despatched General Jean Carteaux (who had been an artist prior to the Revolution), and General La Poype, sending with them whatever troops they could scrape together to quickly recapture the city and regain command of the Mediterranean fleet within. Initial attempts to take some of the circle of fortifications failed dismally and when the commander of the artillery, General Elzéar de Dommartin was wounded, influential friends and the local representative of the National Convention put Napoleon, who had fortunately been passing with a convoy of powder waggons, in command of the guns.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Napoleon showed great activity and purpose; he had guns collected from every possible source, ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("he had retired artillerymen forced back to the guns and he had soldiers trained to fire cannon. Still, they weren’t strong enough to formally besiege Toulon.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("This box depicts Napoleon at Toulon.")])])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("Napoleon commanding the cannon at Toulon.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He therefore conceived a plan to capture some outlying forts named "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L’Eguillette")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Balaguire")]), _vm._v(" on the heights overlooking the entrance of the inner harbour. The capture of these forts would allow his guns to dominate the harbour, preventing any resupply of the city from the sea, including further reinforcements and supplies for the army defending the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General Carteaux only supplied a weak force to attack the forts and it failed with some loss. However, the allies were not slow to realise that this was a weak point, and they quickly built a strong fortification on the crest of the heights. It was named Fort Mulgrave and with three small supporting fortifications, it made the hill almost impregnable. In fact, the French dubbed it ‘Little Gibraltar’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early November, Carteaux was dismissed and he was replaced by General Doppet, a former doctor (he apparently could not stand the sight of blood), who was renowned for his indecision and ineptitude, which he soon displayed in abundance, launching hopeless attacks and constantly changing his plans. He resigned five days later, fully aware of his own incompetence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, he was succeeded by a career soldier, General Jacques Dugommier, who readily recognised the value of Napoleon’s plan and put every effort into the capture of ‘Little Gibraltar’ with his army, which now numbered nearly 45,000 men, heavily outnumbering the allied troops. They constructed numerous batteries to pummel the forts and successfully defeated allied sorties, even capturing General O’Hara.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The final assault on Fort Mulgrave was launched on the night of 16 December, and during the attack Napoleon was the nearest he ever came to being killed in battle, when a ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("British sergeant bayonetted him in the thigh. The position was taken and the quickly-mounted guns began firing on the shipping, forcing the allied warships to move out of the harbour. The fall of Toulon was now inevitable.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_vm._v("The siege of Toulon by Jean-Antoine Fort.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoleon was not able to take part in further operations, but the allied troops quickly began pulling out and an operation was launched to destroy as much of the French fleet and the dockyard as possible before they left. This was botched in the rush to leave, and twenty-five French warships were recaptured intact. Thousands of inhabitants of Toulon desperately sought to escape on the allied ships and nearly 15,000 succeeded, but up to 6,000 drowned in the attempt or were murdered by the revolutionary soldiers. Over the next few weeks another 1,000 were guillotined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Napoleon was not present for this terrifying finale as he lay in bed recuperating from his wound, but news soon arrived of his promotion to Brigadier General and he was ordered to join the Army of Italy.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-789097b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter_06.vue
// module id = 90
// module chunks = 0